
import { defineComponent, onMounted, ref } from 'vue';
import { useI18n } from 'vue-i18n';
import SpmButton from '@/components/spm-primevue/SpmButton.vue';

export default defineComponent({
  name: 'StepShell',

  components: {
    SpmButton,
  },

  props: {
    title: { type: String, default: '' },
    intro: { type: String, default: '' },
    canGoBack: { type: Boolean, default: false },
    continueLabel: { type: String, default: '' },
    continueDisabled: { type: Boolean, default: false },
    continueLoading: { type: Boolean, default: false },
    hideFooter: { type: Boolean, default: false },
  },

  emits: ['next', 'back'],

  setup() {
    const { t } = useI18n();
    const mounted = ref(false);
    onMounted(() => { mounted.value = true; });
    return { t, mounted };
  },
});
